// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"df3964c3","344":"8e99a801","453":"e1d54666"}[chunkId] + ".chunk.js";
};